import { MailIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useClipboard } from "@vega-core/hooks/useClipboard";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  email: string;
};

export const CopyEmailButton = ({ email }: Props) => {
  const { copy } = useClipboard({
    name: m.form_email(),
    withToast: true,
  });

  return (
    <ThemedButton
      ariaLabel={m.btn_copyEmail()}
      dataTestId="copy-email-button"
      icon={<MailIcon />}
      onClick={() => copy(email)}
      variant="secondary"
    >
      {m.btn_copyEmail()}
    </ThemedButton>
  );
};
